((angular) => {
  angular.module("app").directive("forumCategory", forumCategory);

  forumCategory.$inject = [
    "$filter",
    "ForumThreadsApi",
    "GroupsApi",
    "alerts",
    "thisUser",
  ];

  function forumCategory(
    $filter,
    ForumThreadsApi,
    GroupsApi,
    alerts,
    thisUser,
  ) {
    const link = ($scope) => {
      $scope.isLoading = false;
      $scope.joinGroup = joinGroup;
      $scope.request = request;
      $scope.usersGroups = thisUser.groups.map(function (group) {
        return group.id;
      });
      $scope.thisUser = thisUser;

      /**
       * Adds a user to the group
       * @param  {int} groupId - Group's id
       * @return {void}
       */
      function joinGroup(groupId) {
        GroupsApi.addUser(
          { id: groupId },
          {
            user_id: thisUser.id,
          },
          (response) => {
            alerts.emit({
              theme: "success",
              title: "Joined group",
              messages: [],
            });

            $scope.usersGroups.push(groupId);
          },
        );
      }

      /**
       * Sends the connection request to the API
       * @return {void}
       */
      function request(groupId) {
        $scope.isLoadingMessage = "Sending request...";
        $scope.isLoading = true;

        GroupsApi.GroupUserRequest(
          { group_id: groupId },
          {
            user_id: thisUser.id,
          },
          function handleRequestResponse(response) {
            $scope.isLoading = false;

            alerts.emit({
              theme: "success",
              title: "Request Sent",
              messages: [],
            });

            $scope.category.userRequested = true;
          },
          function handleRequestError() {
            $scope.isLoading = false;
            $scope.forceClose = true;
          },
        );
      }

      /**
       * Get threads that are active in this category, for member images,
       * and the latest thread information.
       *
       * @return {void}
       */
      function getThreads() {
        ForumThreadsApi.query(
          { forum_category_id: $scope.category.id },
          (threads) => {
            $scope.threads = threads;

            Object.keys(threads.data).forEach((key) => {
              const thread = threads.data[key];
              const isBefore = window
                .moment($scope.lastActivity)
                .isBefore(thread.last_activity_at);

              if (!$scope.lastActivity || isBefore) {
                $scope.lastActivity = thread.last_activity_at;
              }
            });
          },
        );
      }

      getThreads();

      function checkRequested() {
        $scope.category.userRequested = false;

        if (
          $scope.category.group &&
          $scope.category.group.user_requests.filter(
            (o) => o.user_id === thisUser.id,
          ).length > 0
        ) {
          $scope.category.userRequested = true;
        }
      }
      checkRequested();
    };

    return {
      restrict: "E",
      templateUrl: "directives/forumCategory.html",
      transclude: true,
      link,
      scope: {
        category: "=",
      },
    };
  }
})(angular);
